import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
  idPhoto: null,
  signature: null,
  age_verified: false,
  address_verified: false,
  terms_accepted: false,
  adrStreet: '',
  adrUnit: '',
  adrCity: '',
  adrState: '',
  adrCountry: '',
  adrPostalCode: '',
  mapsLoaded: false,
  mapsLoading: true,
  availability: {},
  booking: {},
  charges: [],
  refunds: [],
  payment_balance_due_date: '',
  payment_balance_due_on: '',
  customer: {},
  customerVerifiedAddress: null,
  customerVerifiedAge: null,
  customerVerifiedId: null,
  customerVerifiedSignature: null,
  featured_image: {},
  listing: {},
  location: {},
  property: {},
  rentalAgreement: {},
  propertyManager: {},
  slug: '',
  unit: {},
  verify_id: null,
  verify_id_description: '',
  verify_signature: null,
  verify_address: null,
  verify_age: null,
  required_age: null,
  contractTermsAndConditions: null
};

const verificationSlice = createSlice({
  name: 'verification',
  initialState,
  reducers: {
    updateVerificationSlice: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetVerificationSlice: state => {
      return { ...state, ...initialState };
    }
  }
});

export const {
  updateVerificationSlice,
  resetVerificationSlice
} = verificationSlice.actions;

export default verificationSlice.reducer;

export const selectVerificationState = createSelector(
  state => state.verification,
  verification => verification
);
